export default __webpack_public_path__ + "images/sommes-uniques-bg.jpg";